export const GENERIC_SERVICE_ERROR =
  "Estamos com algum problema em nossos sistemas e não conseguimos concluir sua solicitação. Por favor, tente de novo mais tarde.";
